function initialState() {
  return { searchTerm: '', tags: [], onFocus: false };
}

export function buyerSearchState(state = initialState(), action) {
  switch (action.type) {
    case 'SET_BUYER_SEARCH_TERM':
      return { ...state, searchTerm: action.searchTerm };
    case 'SET_BUYER_SEARCH_FOCUS':
      return { ...state, onFocus: action.onFocus };
    case 'BUYER_TAGS_VALUE':
      return { ...state, tags: action.tags };
    default:
      return state;
  }
}
